<div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 flex flex-col gap-8">
  <!-- Top: Owner Journey Stepper (3 Main Steps) -->
  @if (isOwnerApp()) {
    <div class="rounded-2xl border border-gray-6 bg-surface-default p-5 shadow-xs">
      <etxe-owner-journey-stepper
        [currentStep]="'creation'"
        [propertyId]="property()._id"
        [property]="property()"
      ></etxe-owner-journey-stepper>
    </div>
  }

  <div class="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
    <!-- Left Sidebar: 10 Micro-Steps Stepper -->
    <div
      class="sticky top-0 z-20 -mx-4 self-start bg-gray-1 px-4 py-4 lg:top-10 lg:z-auto lg:col-span-3 lg:mx-0 lg:bg-transparent lg:px-0 lg:py-0"
    >
      <div class="rounded-2xl border border-gray-6 bg-surface-default p-4 shadow-xs">
        <aura-stepper
          [purpose]="'Création du bien'"
          [steps]="computedSteps()"
          [currentStepIndex]="currentStep()"
          (stepSelected)="onStepSelect($event)"
        ></aura-stepper>
      </div>
    </div>

    <!-- Main Content -->
    <div class="lg:col-span-9">
      <div class="rounded-2xl border border-gray-6 p-6 shadow-sm lg:p-10 surface-default">
        <!-- Dynamic Step Content -->
        @switch (currentStep()) {
          @case (PropertyCreationStep.DEFINITION) {
            <!-- Step 0: Definition -->
            <etxe-property-definition-step
              [dto]="property().definition"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.DEFINITION, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-definition-step>
          }
          @case (PropertyCreationStep.LOCATION) {
            <!-- Step 1: Location -->
            <etxe-property-location-step
              [dto]="property().location"
              [isLocked]="!!property()._id"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.LOCATION, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-location-step>
          }
          @case (PropertyCreationStep.CADASTRAL) {
            <!-- Step 2: Cadastre -->
            <etxe-property-cadastral-step
              [dto]="property().geospatial?.cadastral"
              [addressLabel]="property().location.address?.label"
              [cityCode]="property().location.address?.cityCode"
              [coordinates]="property().location.coordinates"
              [isConfirmed]="isCadastralConfirmed()"
              [isLocked]="!!property()._id"
              (dtoChanged)="onCadastralUpdated($event)"
              (confirmationChanged)="onCadastralConfirmationChanged($event)"
            ></etxe-property-cadastral-step>
          }
          @case (PropertyCreationStep.DPE) {
            <!-- Step 3: DPE -->
            <etxe-property-dpe-form
              [propertyLocation]="property().location"
              [dto]="property().dpe"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.DPE, $event)"
              (validityChanged)="onStepValidityChanged($event)"
              (technicalExtracted)="onDpeTechnicalExtracted($event)"
            ></etxe-property-dpe-form>
          }
          @case (PropertyCreationStep.KEY_INFOS) {
            <!-- Step 4: Key Infos -->
            <etxe-property-key-infos-form
              [propertyDefinition]="property().definition"
              [dto]="property().keyInfo"
              [cadastral]="property().geospatial?.cadastral"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.KEY_INFOS, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-key-infos-form>
          }
          @case (PropertyCreationStep.CONSTRUCTION) {
            <!-- Step 5: Construction -->
            <etxe-property-construction-form
              [propertyDefinition]="property().definition"
              [propertyDpe]="property().dpe"
              [dto]="property().construction"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.CONSTRUCTION, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-construction-form>
          }
          @case (PropertyCreationStep.CHARACTERISTICS) {
            <!-- Step 6: Characteristics -->
            <etxe-property-characteristics-form
              [propertyDefinition]="property().definition"
              [propertyKeyInfo]="property().keyInfo"
              [propertyIsCoOwnership]="!!property().keyInfo.coOwnership?.isInCoOwnership"
              [dto]="property().characteristics"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.CHARACTERISTICS, $event)"
              (validityChanged)="onStepValidityChanged($event)"
              [isSkippable]="true"
              (skipped)="nextStep()"
            ></etxe-property-characteristics-form>
          }
          @case (PropertyCreationStep.GEOHAZARDS) {
            <!-- Step 6: Géospatial -->
            <etxe-property-geospatial-display
              [property]="property()"
              [fetchData]="true"
              (propertyRefreshed)="onGeospatialRefreshed($event)"
            ></etxe-property-geospatial-display>
          }
          @case (PropertyCreationStep.PRESENTATION) {
            <!-- Step 7: Presentation -->
            <etxe-property-presentation-form
              [propertyId]="property()._id"
              [dto]="property().presentation"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.PRESENTATION, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-presentation-form>
          }
          @case (PropertyCreationStep.PHOTOS) {
            <!-- Step 8: Photos -->
            <etxe-property-photos-form
              [propertyId]="property()._id"
              [dto]="{ photos: property().media.photos || [] }"
              [propertyCharacteristics]="property().characteristics"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.PHOTOS, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-photos-form>
          }
          @case (PropertyCreationStep.FINANCIALS) {
            <!-- Step 8: Financials -->
            <etxe-property-financials-form
              [propertyId]="property()._id"
              [dto]="property().financials"
              [propertyIsCoOwnership]="!!property().keyInfo.coOwnership?.isInCoOwnership"
              [residenceType]="property().definition.residenceType"
              [habitableSurface]="property().keyInfo.surface.habitable"
              [isNewBuild]="property().construction?.year === PropertyConstructionPeriod.SINCE_2019"
              [propertyLocation]="property().location"
              [propertyType]="property().definition?.propertyType"
              [propertyDvf]="property().geospatial?.dvf"
              (dtoChanged)="onStepDtoChanged(PropertyCreationStep.FINANCIALS, $event)"
              (validityChanged)="onStepValidityChanged($event)"
            ></etxe-property-financials-form>
          }
        }

        <!-- Footer Actions -->
        <div class="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-gray-6 pt-6">
          <div>
            @if (currentStep() > PropertyCreationStep.DEFINITION) {
              <button mat-stroked-button (click)="previousStep()">Retour</button>
            }
          </div>

          <div class="flex items-center gap-3">
            @if (
              currentStep() === PropertyCreationStep.CADASTRAL &&
              isStepCompleted(PropertyCreationStep.CADASTRAL) &&
              !isCadastralConfirmed()
            ) {
              <span
                class="text-xs text-amber-11 font-medium flex items-center gap-1.5 bg-amber-a2 border border-amber-a4 px-3 py-1.5 rounded-lg"
              >
                <mat-icon class="text-sm leading-none">info</mat-icon>
                <span>Cochez la confirmation de parcelle ci-dessus pour continuer</span>
              </span>
            }

            @if (loading()) {
              <button mat-flat-button class="primary" disabled>
                <mat-spinner diameter="24"></mat-spinner>
              </button>
            } @else {
              <button mat-flat-button class="primary" (click)="nextStep()" [disabled]="!canProceed()">
                @if (currentStep() < steps().length - 1) {
                  Continuer
                } @else {
                  Terminer
                }
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
